import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import * as i18next from 'i18next';
import * as api from 'core/api';
// eslint-disable-next-line @typescript-eslint/no-var-requires
const WithRender = require('./template.html');

@WithRender
@Component
export default class AccountProductsBuyOrderComponent extends Vue {
    @Prop()
    orderGuid: string;

    view = 'loading';

    reservation: api.ReservationInfo | null = null;

    selectedProductIdsOnOrderPage: number[] = [];

    selectedProduct: api.Product | any = {
        adapter: '',
        id: 0,
        name: '',
        description: '',
        cancelPossible: false,
        productReservationId: 0,
        type: '',
        status: ''
    };

    get orderNumber() {
        if (this.reservation) {
            return i18next.t('label_with_number', { i: this.reservation.reservationNumber });   
        } else {
            return null;
        }
    }

    get totalCostOnOrderPage() {
        let total = 0;
        
        for (const id of this.selectedProductIdsOnOrderPage) {
            const product = this.reservation!.productsOnOrderPage.products.find(p => p.id === id)!;
            total += product.price;
        }

        return total;
    }

    get productsPurchaseUrl() {
        const ct = this.$route.query.ct ? <api.ProductChoiceType>parseInt(<string>this.$route.query.ct) : api.ProductChoiceType.notSet;
        const ids = this.selectedProductIdsOnOrderPage.join('_');
        return `/order/booking/product/${this.orderGuid}/${ids}?ct=${ct}`;
    }

    mounted() {
        new api.ReservationService().getReservationStatus(this.orderGuid, true, false).then(
            (result: api.GetReservationStatusResult) => {
                this.reservation = result.reservationInfo;

                this.view = 'view';
            },
            (error) => {
                console.error(error);
            }
        );
    }

    detailProductOnSale(index: number) {
        this.selectedProduct = this.reservation!.productsOnOrderPage.products[index];
        (<any>this.$refs).modalProduct.isActive = true;
    }
}
